"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelCardOfferInfo = void 0;
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _localization = require("@lt/localization");
var _Moon = _interopRequireDefault(require("../../../icons-react/userflow/Moon"));
var _QuestionCircle = _interopRequireDefault(require("../../../icons-react/QuestionCircle"));
var _CurrencyFormat = _interopRequireDefault(require("../../CurrencyFormat"));
var _Bubble = _interopRequireDefault(require("../../Bubble"));
var _constants = require("../constants");
var _date = require("../../../utils/date");
// Icons:

var HotelCardOfferInfo = function HotelCardOfferInfo(_ref) {
  var date = _ref.date,
    nightsCount = _ref.nightsCount,
    surcharge = _ref.surcharge,
    currencyCode = _ref.currencyCode,
    isSmallCard = _ref.isSmallCard,
    className = _ref.className,
    isHotelOnly = _ref.isHotelOnly,
    isFlexDates = _ref.isFlexDates;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var isSurchargeKnown = !(0, _isNil2["default"])(surcharge);
  var bubbleText = isSurchargeKnown ? _constants.KNOWN_SURCHARGE_TOOLTIP : _constants.UNKNOWN_SURCHARGE_TOOLTIP;
  var surchargeText = isSmallCard ? _constants.SMALL_CARD_SURCHARGE_TEXT : _constants.SURCHARGE_TEXT;
  var endDate = (0, _addDays["default"])(new Date(date), nightsCount);
  var shortEndDate = (0, _date.formatDate)(endDate, 'd MMM');
  return /*#__PURE__*/_react["default"].createElement(StyledOfferInfo, {
    isSmallCard: isSmallCard
  }, /*#__PURE__*/_react["default"].createElement(Column, {
    className: className
  }, !isHotelOnly && /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    width: "normal",
    text: bubbleText
  }, /*#__PURE__*/_react["default"].createElement(StyledSurcharge, null, isSurchargeKnown ? /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    prefix: t('hotelcard.card.offer.include'),
    value: surcharge,
    currencyCode: currencyCode
  }) : surchargeText, /*#__PURE__*/_react["default"].createElement(Icon, null, /*#__PURE__*/_react["default"].createElement(_QuestionCircle["default"], null)))), isFlexDates ? /*#__PURE__*/_react["default"].createElement(StyledDateRange, null, (0, _date.getDateRange)((0, _date.formatDate)(date, 'd MMM'), shortEndDate, nightsCount), ' ', /*#__PURE__*/_react["default"].createElement(StyledMoonIcon, null)) : null));
};
var StyledMoonIcon = (0, _styledComponents["default"])(_Moon["default"]).withConfig({
  displayName: "HotelCardOfferInfo__StyledMoonIcon",
  componentId: "sc-1qswa3a-0"
})(["margin-left:2px;margin-right:2px;height:13px;width:13px;path{fill:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackLight;
});
var Column = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardOfferInfo__Column",
  componentId: "sc-1qswa3a-1"
})(["display:flex;flex-direction:column;"]);
var Row = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardOfferInfo__Row",
  componentId: "sc-1qswa3a-2"
})(["display:flex;flex-direction:row;align-items:center;max-height:16px;line-height:16px;"]);
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "HotelCardOfferInfo__StyledBubble",
  componentId: "sc-1qswa3a-3"
})(["vertical-align:middle;"]);
var Icon = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardOfferInfo__Icon",
  componentId: "sc-1qswa3a-4"
})(["svg{stroke:none !important;fill:none !important;stroke-width:1 !important;circle{stroke:#919499;}path{fill:#919499;}}margin-left:4px;width:16px;height:16px;"]);
var StyledSurcharge = (0, _styledComponents["default"])(Row).withConfig({
  displayName: "HotelCardOfferInfo__StyledSurcharge",
  componentId: "sc-1qswa3a-5"
})(["color:#4d4d4d;margin-bottom:10px;cursor:default;"]);
var StyledDateRange = (0, _styledComponents["default"])(Row).withConfig({
  displayName: "HotelCardOfferInfo__StyledDateRange",
  componentId: "sc-1qswa3a-6"
})(["color:#17181a;"]);
var StyledOfferInfo = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardOfferInfo__StyledOfferInfo",
  componentId: "sc-1qswa3a-7"
})(["margin-top:4px;font-size:14px;line-height:16px;color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackLight;
});
var MemoedHotelCardOfferInfo = exports.HotelCardOfferInfo = /*#__PURE__*/_react["default"].memo(HotelCardOfferInfo);